import { useParams } from "react-router-dom";
import { Container } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { useGetEventQuery } from "event/api/event.api";
import { ClickAndCollectPDFView } from "./ClickAndCollectPDFView";
import {
  DESKTOP_ORANGE_BACKGROUND,
  // MOBILE_PURPLE_BACKGROUND,
} from "../../_graphic_design";

export function ClickAndCollectPDFPresenter() {
  const { eventId } = useParams<{ eventId: string }>();
  const { data, isSuccess } = useGetEventQuery(eventId as string);

  const backGroundDesktopUrl =
    data?.images?.eventDesktopBackground || DESKTOP_ORANGE_BACKGROUND;
  const backGroundMobileUrl = data?.images?.eventMobileBackground || "";

  const styles = {
    desktopBackground: {
      backgroundImage: `url(${backGroundDesktopUrl})`,
      backgroundSize: "auto",
      backgroundPosition: "",
      backgroundRepeat: "no-repeat",
    },
    mobileBackground: {
      backgroundImage: `url(${backGroundMobileUrl})`,
      backgroundSize: "auto",
      backgroundPosition: "",
      backgroundRepeat: "no-repeat",
      maxWidth: 768,
    },
  };

  const { width } = useViewportSize();
  const isMobile = width <= 768;
  const currentStyle = isMobile
    ? styles.mobileBackground
    : styles.desktopBackground;

  return (
    <Container
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
        minHeight: "100dvh",
        maxWidth: "none",
        textAlign: "center",
        paddingTop: "2.5%",
        ...currentStyle,
      }}
    >
      {isSuccess && data && data.food_menu ? (
        <ClickAndCollectPDFView foodMenuId={data.food_menu} />
      ) : null}
    </Container>
  );
}
